import styles from "./addReportPage.module.css";

import { useEffect, useState } from "react";
import { Input } from "../../../components/input/input";
import { Button } from "../../../components/button/button";
import { Separator } from "../../../components/separator/separator";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import { addDays } from "../../../utils/addDays";
import { useParams } from "react-router";
import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { Checkbox } from "../../../components/checkbox/checkbox";
import { Text } from "../../../components/text/text";
import CheckListAPI from "../../../api/CheckListAPI";

export const CreateCafeReportPage = () => {
    const { cafeId } = useParams();

    const [selectedObjectNames, setSelectedObjectNames] = useState([]);
    const [objectNamesError, setObjectNamesError] = useState(false);
    const [objectNameOptions, setObjectNameOptions] = useState([]);

    const [startDate, setStartDate] = useState(addDays(new Date(), -7));
    const [endDate, setEndDate] = useState(new Date());
    const [dateError, setDateError] = useState(false);

    useEffect(() => setObjectNamesError(false), [selectedObjectNames]);
    useEffect(() => setDateError(false), [startDate, endDate]);

    useEffect(() => {
        if (!cafeId) return;

        CheckListAPI
            .fetchAdminCafeReportObjectNames(cafeId)
            .then((res) => {
                const options = [...new Set((res || []).map((name) => (name || "").trim()).filter(Boolean))];
                setObjectNameOptions(options);
                setSelectedObjectNames(options);
            })
            .catch(console.error);
    }, [cafeId]);

    const toggleObjectName = (objectName) => {
        setSelectedObjectNames((prev) => {
            if (prev.includes(objectName)) {
                return prev.filter((name) => name !== objectName);
            }
            return [...prev, objectName];
        });
    };

    const areAllSelected =
        objectNameOptions.length > 0 && selectedObjectNames.length === objectNameOptions.length;

    const toggleSelectAll = () => {
        if (areAllSelected) {
            setSelectedObjectNames([]);
            return;
        }
        setSelectedObjectNames(objectNameOptions);
    };

    const validate = () => {
        let error = false;

        if (objectNameOptions.length > 0 && selectedObjectNames.length === 0) {
            setObjectNamesError(true);
            error = true;
        }

        if (!startDate || !endDate || startDate.getTime() > endDate.getTime()) {
            setDateError(true);
            error = true;
        }

        return error;
    }

    const [saving, setSaving] = useState(false);
    const navigate = useAnimatedNavigate();
    const onSave = () => {
        if (validate()) return;

        setSaving(true);
        CheckListAPI
            .createCafeReport(cafeId, startDate, endDate, selectedObjectNames)
            .then(() => navigate(`/admin/${cafeId}/cafe/reports`))
            .catch(console.error)
            .finally(() => setSaving(false));
    }

    return (
        <>
            <AdminHeader title="Сгенерировать отчет" />

            <div className={styles.objectSelectorBlock}>
                <div className={styles.objectSelectorHeader}>
                    <Text as="div" variant="bodyStrong" className={styles.objectSelectorTitle}>
                        Объекты для отчета
                    </Text>
                    <button
                        type="button"
                        className={styles.selectAllButton}
                        onClick={toggleSelectAll}
                    >
                        {areAllSelected ? "Снять все" : "Выбрать все"}
                    </button>
                </div>

                {
                    objectNameOptions.length > 0 ? (
                        <div className={styles.objectSelectorList}>
                            {
                                objectNameOptions.map((objectName) => (
                                    <div
                                        key={objectName}
                                        className={styles.objectSelectorItem}
                                    >
                                        <Checkbox
                                            checked={selectedObjectNames.includes(objectName)}
                                            onChange={() => toggleObjectName(objectName)}
                                            error={objectNamesError}
                                        />
                                        <button
                                            type="button"
                                            className={styles.objectNameButton}
                                            onClick={() => toggleObjectName(objectName)}
                                        >
                                            <Text as="span" variant="body" className={styles.objectSelectorText}>
                                                {objectName}
                                            </Text>
                                        </button>
                                    </div>
                                ))
                            }
                        </div>
                    ) : (
                        <Text as="div" variant="body" className={styles.objectSelectorEmpty}>
                            Нет доступных объектов для выбора
                        </Text>
                    )
                }

                {
                    objectNamesError &&
                    <Text as="div" variant="caption" className={styles.objectSelectorError}>
                        Выберите хотя бы один объект
                    </Text>
                }
            </div>

            <Input
                label="Дата начала"
                type="date"
                value={startDate.toISOString().split("T")[0]}
                setValue={(val) => {
                    try {
                        const newDate = new Date(val);
                        newDate.toISOString();
                        setStartDate(newDate);
                    } catch {
                        setStartDate(prev => prev);
                    }
                }}
                error={dateError}
            />

            <Input
                label="Дата конца"
                type="date"
                value={endDate.toISOString().split("T")[0]}
                setValue={(val) => {
                    try {
                        const newDate = new Date(val);
                        newDate.toISOString();
                        setEndDate(newDate);
                    } catch {
                        setEndDate(prev => prev);
                    }
                }}
                error={dateError}
            />

            <Separator />

            <Button
                fixed
                disabled={saving}
                text="Сохранить"
                onClick={onSave}
            />
        </>
    );
}